module.exports = __webpack_public_path__ + "img/box3_icon4.83d46a3f.png";